import * as queries from './query';
import * as mutations from './mutation';

export { queries, mutations };
export default { ...queries, ...mutations };
